import { detectIncognito } from "detectincognitojs";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const generateDeviceId = async function () {
  // const fpPromise = import("https://openfpcdn.io/fingerprintjs/v4").then(
  //   (FingerprintJS) => FingerprintJS.load()
  // );

  const fpPromise = FingerprintJS.load();
  // Get the visitor identifier when it's ready
  let storageDeviceId = localStorage.getItem("deviceId");
  console.log("storageDeviceId: " + storageDeviceId);
  if (storageDeviceId) {
    return storageDeviceId;
  } else {
    return await fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        // This is the visitor identifier
        let visitorId = result.visitorId;
        console.log("produced deviceId", visitorId);
        return detectIncognito().then((result) => {
          console.log("isIncognito", result.browserName, result.isPrivate);
          let _visitorId = result.isPrivate
            ? `${visitorId}incognito`
            : visitorId;
          console.log("visitorId", _visitorId);
          localStorage.setItem("deviceId", _visitorId);
          return _visitorId;
        });

        //   // Check if the user is in Incognito mode
        //   return isIncognitoMode().then((isIncognito) => {
        //     console.log("isIncognitoPromise", isIncognito);
        //     let _visitorId = isIncognito ? `${visitorId}incognito` : visitorId;
        //     console.log("isIncognitoMode???", _visitorId);

        //     // Return the final visitor ID
        //     return _visitorId;
        //   });
      })
      .catch((error) => {
        console.error("Failed to load FingerprintJS:", error);
      });
  }
};

export default generateDeviceId;

function isIncognitoMode() {
  return new Promise((resolve) => {
    const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
    if (!fs) {
      resolve(false); // If not supported, assume not Incognito
    } else {
      fs(
        window.TEMPORARY,
        100,
        () => resolve(false), // Not Incognito
        () => resolve(true) // Incognito
      );
    }
  });
}
